/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import {
  Form, Row, Col, Checkbox, Space, Spin, message,
} from 'antd';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  FormItem,
} from '../Forms';

import ConfirmButton from './buttons/ConfirmButton';
import { OkayButton } from './buttons';
import { CustomCheckBox } from '../Containers';
import { ConsentService } from '../../services';

const CONSENT_ALREADY_GIVEN_VIEW = 'CONSENT_ALREADY_GIVEN_VIEW';

export const CompanyName = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0px;
`;

const CompanyConsents = ({
  companyId, invitingCompany, successScreenUrl, companiesConsents, consentType, view, setView, spin, setSpin,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [clickConfirmFailed, setClickConfirmFailed] = useState(false);
  const initialValidForm = companiesConsents.filter(({ exists }) => exists).length > 0;
  const [validForm, setValidCompaniesForm] = useState(initialValidForm);

  const onFinishCompaniesForm = (values) => {
    const givingCompaniesIds = Object.entries(values)
      .filter(([key, value]) => value && !companiesConsents
        .filter((consentCompany) => key === consentCompany.companyId)[0].exists)
      .map(([key]) => key);
    if (givingCompaniesIds.length) {
      const command = {
        type: consentType,
        givingCompaniesIds,
        recipientCompanyId: companyId,
      };
      ConsentService.createConsents(command)
        .then(() => {
          window.location.href = successScreenUrl;
        })
        .catch((error) => {
          const payload = error.response.data;
          switch (payload?.errorCode) {
            case 'CONSENT_BETWEEN_SAME_COMPANY_NOT_ALLOWED':
              setView(CONSENT_ALREADY_GIVEN_VIEW);
              break;
            default:
              message.error(t('GENERIC_ERROR'));
          }
          setSpin(false);
        });
    } else if (initialValidForm) {
      window.location.href = successScreenUrl;
    } else {
      setClickConfirmFailed(true);
    }
  };

  const onValidCompaniesFrom = () => {
    if (companiesConsents.filter(({ exists }) => !exists)
      .some((companyConsent) => form.getFieldValue(companyConsent.companyId) === true)) {
      setValidCompaniesForm(true);
      setClickConfirmFailed(false);
    } else {
      setValidCompaniesForm(false);
    }
  };

  const companyConsentExistsOrIsSame = (companyConsent) => (
    companyConsent.exists || companyConsent.companyId === companyId
  );

  const isFailedFormAndUncheckedBox = (field) => clickConfirmFailed
    && (form.getFieldValue(field) === undefined
      || form.getFieldValue(field) === false);

  return (
    <Spin spinning={spin}>
      {view === CONSENT_ALREADY_GIVEN_VIEW
        ? (
          <>
            <Row justify="center" style={{ marginTop: '72px' }}>
              <Col span={5} />
              <Col span={14}>
                {t('FORM_USER_ACCOUNT.CONSENT_ALREADY_GIVEN')}
              </Col>
              <Col span={5} />
            </Row>
            <Row justify="center" style={{ marginTop: '72px' }}>
              <Col span={12}>
                <OkayButton
                  execute={() => { window.location.href = successScreenUrl; }}
                />
              </Col>
            </Row>
          </>
        )
        : (
          <>
            <Form
              form={form}
              onChange={() => !initialValidForm && onValidCompaniesFrom()}
              onFinish={(v) => onFinishCompaniesForm(v)}
            >
              <Row style={{ marginTop: '24px' }}>
                <Col span={4} />
                <Col span={16} style={{ textAlign: 'justify' }}>
                  <Trans
                    key="FORM_USER_ACCOUNT.YOU_BELONG_TO_MULTIPLE_COMPANIES"
                    i18nKey="FORM_USER_ACCOUNT.YOU_BELONG_TO_MULTIPLE_COMPANIES"
                  >
                    <b>{{ invitingCompany }}</b>
                  </Trans>
                </Col>
                <Col span={4} />
              </Row>
              {
                clickConfirmFailed
                  ? (
                    <Row style={{ marginTop: '18px' }}>
                      <Col span={4} />
                      <Col span={16} style={{ color: 'red', fontSize: '12px' }}>
                        {t('FORM_USER_ACCOUNT.SELECT_ANY_COMPANY_WARNING')}
                      </Col>
                      <Col span={4} />
                    </Row>
                  ) : (<></>)
              }
              <Row style={{ marginTop: clickConfirmFailed ? '18px' : '48px' }}>
                <Col span={4} />
                <Col span={16}>
                  <Checkbox.Group>
                    <Space direction="vertical">
                      {companiesConsents.map((companyConsent) => (
                        <FormItem
                          style={{
                            width: 'full',
                            marginBottom: '0px',
                          }}
                          key={companyConsent.companyId}
                          name={companyConsent.companyId}
                          initialValue={companyConsent.exists}
                          valuePropName="checked"
                          rules={[
                            {
                              required: false,
                              type: 'boolean',
                            },
                          ]}
                        >
                          <CustomCheckBox
                            disabled={companyConsentExistsOrIsSame(companyConsent)}
                            color={isFailedFormAndUncheckedBox(companyConsent.companyId) ? 'red' : undefined}
                          >
                            <CompanyName style={
                              { color: companyConsentExistsOrIsSame(companyConsent) ? '#BDBDBD' : '#333333' }
                            }
                            >
                              <Trans key={companyConsent.companyName} i18nKey={companyConsent.companyName} />
                            </CompanyName>
                          </CustomCheckBox>
                        </FormItem>
                      ))}
                    </Space>
                  </Checkbox.Group>
                </Col>
                <Col span={4} />
              </Row>
              <Row justify="center" style={{ marginTop: '48px' }}>
                <Col span={12}>
                  <Form.Item>
                    <ConfirmButton disabled={validForm} execute={() => form.submit()} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </>
        )}
    </Spin>
  );
};

export default CompanyConsents;

CompanyConsents.propTypes = {
  companyId: PropTypes.string.isRequired,
  invitingCompany: PropTypes.string.isRequired,
  successScreenUrl: PropTypes.string.isRequired,
  companiesConsents: PropTypes.array.isRequired,
  consentType: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  setView: PropTypes.func.isRequired,
  spin: PropTypes.string.isRequired,
  setSpin: PropTypes.func.isRequired,
};
